<div class="infinite-scroll-target" bind:this={observable} />

<style>
    .infinite-scroll-target {
        display: block;
        opacity: 0;
        height: 1px;
    }
</style>

<script lang="ts">
    import client from "@/utils/http";

    let observable: HTMLDivElement;
    export let url: string = window.location.toString();
    export let key: string = "page";
    export let initial: string = "1";
    export let target: string = "body";

    let currentObserver: IntersectionObserver|null = null;
    let isIntersecting = false;
    let running = false;

    let page = Number(initial);
    $: page = Number(initial);

    let done = false;
    $: done = [page !== (/* intentionally always false */"never" as any), false][1]

    function buildURL(u: string, k: string, p: number): string {
        const url = new URL(u);
        const q = url.searchParams;
        q.set(k, ""+p);
        return url.toString();
    }

    const parser = new DOMParser();
    async function dispatchReload(): Promise<boolean> {
        const targetElement: HTMLElement|null = document.querySelector(target);
        if (targetElement === null) return true;

        const { apply } = await import("../../lib/merger");
        const response = await client.get<string>(buildURL(url, key, page), {headers: {"Accept": "text/html"}, responseType: "document"});
        const sheet = parser.parseFromString(response.data, response.headers["Content-Type"]||"text/html");

        const sourceElement: HTMLElement|null = sheet.querySelector(target);
        if (sourceElement === null) return true;
        apply(targetElement, sourceElement);

        return !!sheet.querySelector('[data-tm-infinite-marker="end"]');
    }

    async function implementIntersect() {
        if (done) return;
        if (running) return;
        running = true;
        while (isIntersecting) {
            try {
                page++;
                if (await dispatchReload()) {done = true; break;}
            } catch (e) {
                window.reportError(e);
                break;
            }
            await new Promise(rs => requestAnimationFrame(() => requestAnimationFrame(rs)));
        }
        running = false;
    }

    $: if (isIntersecting) implementIntersect();

    function buildObserver(elem: HTMLDivElement) {
        if (!!currentObserver) {
            currentObserver.disconnect();
            currentObserver = null;
            isIntersecting = false;
        }

        if (!!elem) {
            currentObserver = new IntersectionObserver((entries) => {
                for (let entry of entries) {
                    if (entry.isIntersecting != isIntersecting) {
                        isIntersecting = entry.isIntersecting;
                    }
                }
            });
            currentObserver.observe(elem);
        }
    }

    $: buildObserver(observable);
</script>
